/*eslint-disable */
define(function(require) {
    var _ = require('underscore');
    var Backbone = require('backbone');
    var pageConfig = require('common/page-config');
    var numberFormatter = require('common/formatter/number-formatter');
    var priceFormatter = require('common/formatter/price-formatter');
    var discountFormatter = require('common/formatter/discount-formatter');
    var moment = require('moment');
    var Mustache = require('mustache');

    var cms = pageConfig.cms.discount;

    return Backbone.Model.extend({
        constructor: function() {
            Backbone.Model.apply(this, arguments);
        },

        validation: null,

        getTemplateValues: function () {
            var data = {
                label: this.getLabel(),
                value: this.formatValue()
            };

            // if item has an expiry date add it
            if (this.get('expiryDate')) {
                _.extend(data, this.formatExpiryDate());
            }
            // if item has a minimum spend add it
            if (this.get('minimumSpend')) {
                _.extend(data, this.formatMinSpend());
            }
            // check if it is an app exclusive discount
            if(this.getLabel() === 'app2') {
                _.extend(data, this.appExclusive());
            }

            return data;
        },

        getTypeName: function () {
            return cms.label[this.get('type').toLowerCase().replace('_', '-')];
        },

        getLabel: function () {
            if (this.get('description')) {
                return this.get('description');
            } else {
                return this.getTypeName();
            }
        },

        getFullLabel: function () {
            if (this.get('description')) {
                return this.get('description');
            } else if (this.get('promotion')) {
                return this.get('promotion').name;
            } else {
                return this.formatAmount() + ' ' + this.getTypeName();
            }
        },

        getInUseValue: function() {
            if (this.inUse) {
                if (this.validation) {
                    return this.validation.value.amount;
                } else {
                    return this.get('amount').amount;
                }
            } else {
                return 0;
            }
        },

        getUseValue: function() {
            if (this.validation) {
                return this.validation.value.amount;
            } else {
                return this.get('amount').amount;
            }
        },

        formatAmount: function() {
            if (this.get('creditAmount')) {
                return priceFormatter.format(this.get('creditAmount'), true);
            } else {
                return priceFormatter.format(this.get('amount'), true);
            }
        },

        formatValidationValue: function() {
            if (this.validation && this.validation.value) {
                return priceFormatter.format(this.validation.value, true, false);
            } else {
                // Should not happen; this is safety net.
                return this.formatAmount();
            }
        },

        formatValue: function () {
            var value;
            var amount = this.get('amount');
            var percentage = this.get('percentage');
            var valueClass = '';

            // has amount
            if (amount) {
                value = priceFormatter.format(amount, true);
            }

            // has percentage
            if (percentage) {
                value = discountFormatter.format(percentage) + '%';
            }

            if ((amount && amount.amount > 99) || (percentage > 99)) {
                valueClass = 'small';
            }

            return {
                value: value,
                label: cms.value['off-label'],
                valueClass: valueClass
            };
        },

        formatExpiryDate: function () {
            var type = 'default';
            var date = moment(this.get('expiryDate')).format('MMM D, YYYY');
            var diff = this.getDayDifferenceFromNow(date);

            if (diff < 30) {
                type = 'badge';
                date = this.getBadgeText(type, diff);
            }

            return {
                expiryDate: {
                    value: cms['expiry-date'][type] + ' ' + date,
                    withBadge: type === 'badge'
                }
            };
        },

        getBadgeText: function (type, diff) {
            var date = cms['expiry-date'][type + '-prefix'] + diff + (diff === 1 ? cms['expiry-date'][type + '-day'] : cms['expiry-date'][type + '-days']);

            if (diff === 0) {
                date = cms['expiry-date'][type + '-today'];
            }

            return date;
        },

        getTimeFrom: function (date) {
            var startOfToday = moment().startOf('day');
            var startOfDate = moment(date).startOf('day');

            return startOfToday.from(startOfDate, true);
        },

        getDayDifferenceFromNow: function(date) {
            var startOfToday = moment().startOf('day');
            var startOfDate = moment(date).startOf('day');

            return startOfDate.diff(startOfToday, 'days');
        },

        formatMinSpend: function () {
            return {
                minSpend: cms['min-spend'].label + ' ' + priceFormatter.format(this.get('minimumSpend'), true)
            };
        },

        appExclusive: function () {
            return {
                appExclusive: cms['app-exclusive'].message
            };
        }
    });
});
